import { Directive, HostListener } from '@angular/core';
import { JarwisService } from 'src/app/Services/jarwis.service';

@Directive({
  selector: '[appNoRightClickConditional]',
})
export class NoRightClickDirectiveConditional {

    permission:any;
  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    if(this.permission=='0'){
        event.preventDefault();
    }
  }
  
  @HostListener('document:keydown', ['$event'])
  onKeyDown (event) {
    if (event.keyCode == 35) {
      event.preventDefault()
    }
  }

  constructor(
      private jarwis : JarwisService
  ) {
    this.jarwis.checkRightClickPermission().subscribe(data=>{
        if(data['type']=="Success"){
            this.permission = data['permission'];
        }
    });
  }
}
